import getInstance from './instance';

export default class TrackOrderApi {
  static async getOrderStatus ({ code }) {
    const instance = await getInstance();
    const { data } = await instance.get('/track-order', { params: { code } });
    return data;
  }
}